<template>
	<div class="area-box">
		<div class="area flex-center" ref="area" @mousedown="createArea">
			<img :src="image" alt="">
			
			<div v-for="(item, i) in areaList" :key="i" class="area-item flex-center" :active="item.active"
				:style="{'z-index': item.index, 'left': `${item.x}px`, 'top': `${item.y}px`, 'width': `${item.w}px`, 'height': `${item.h}px`}"
				@mousedown.stop="moveHandle($event, item)"
			>
				<div v-for="(handle, j) in resizeList" :key="j" class="area-item-handle" @mousedown.stop="resizeHandle(item, j+1)"></div>
				<span>热区{{i+1}}</span>
			</div>
		</div>
		<div class="area-handle flex-between-center">
			<div>
				<a v-show="areaList.length" @click="areaList = []">清除热区</a>
			</div>
			<a @click="uploadImage">选择图片</a>
		</div>
		
		<div v-for="(item, i) in areaList" :key="i" class="area-link flex-center">
			<label>热区{{i+1}}：</label>
			<c-link v-model="item.link" class="flex-grow" :template="$route.query.id"></c-link>
			<a @click="areaList.splice(i, 1)"><i class="tf tf-cross"></i></a>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			code: String
		},
		
		data() {
			return {
				image: '',
				areaIndex: 2,
				areaList: [],
				resizeList: new Array(4)
			}
		},
		
		methods: {
			set(data) {
				data = data[this.code];
				if (data) {
					this.image = data.image;
					if (data.list) {
						this.areaList = data.list.map(item => {
							return {
								index: 1,
								active: true,
								x: item.x,
								y: item.y,
								w: item.width,
								h: item.height,
								link: item.link
							}
						})
					}
				}
			},
			
			async submit() {
				return {
					[this.code]: {
						image: this.image,
						list: this.areaList.map(item => {
							return {
								x: item.x,
								y: item.y,
								width: item.w,
								height: item.h,
								link: item.link
							}
						})
					}
				};
			},
			
			uploadImage() {
				this.selectMedia({
					resolve: data => {
						this.image = data;
						this.areaList = [];
					}
				});
			},
			
			createArea(e) {
				let item = {
					index: 1,
					active: true,
					x: e.layerX,
					y: e.layerY,
					w: 0,
					h: 0,
					link: ''
				};
				this.areaList.push(item);
				this.resizeHandle(item, 3);
			},
			
			moveEvent(e) {
				let rect = this.$refs.area.getBoundingClientRect();
				if (this._resizeEvent) {
					if ([1, 2].includes(this._resizeEvent.type)) {
						// 向上
						let maxY = this._resizeEvent.start.y + this._resizeEvent.start.h - 25,
							top = e.clientY - rect.top - 4;
						this._resizeEvent.data.y = Math.max(0, Math.min(maxY, top));
						this._resizeEvent.data.h = this._resizeEvent.start.h + this._resizeEvent.start.y - this._resizeEvent.data.y;
					} else {
						// 向下
						var minY = this._resizeEvent.start.y - rect.top,
							maxY = rect.height + rect.top - 4;
							
						var height = Math.max(minY, Math.min(maxY, e.clientY)) - this._resizeEvent.start.y + 4;
							
						this._resizeEvent.data.h = Math.max(25, height);
					}
					
					if ([1, 4].includes(this._resizeEvent.type)) {
						// 向左
						let maxX = this._resizeEvent.start.x + this._resizeEvent.start.w - 25,
							left = e.clientX - rect.left - 4;
						this._resizeEvent.data.x = Math.max(0, Math.min(maxX, left));
						this._resizeEvent.data.w = this._resizeEvent.start.w + this._resizeEvent.start.x - this._resizeEvent.data.x;
					} else {
						// 向右
						var minX = this._resizeEvent.start.x - rect.left,
							maxX = rect.width + rect.left - 4;
							
						var width = Math.max(minX, Math.min(maxX, e.clientX)) - this._resizeEvent.start.x + 4;
							
						this._resizeEvent.data.w = Math.max(25, width);
					}
				} else if (this._moveEvent) {
					let left = e.clientX - rect.left - 4 + this._moveEvent.start.x,
						top = e.clientY - rect.top - 4 + this._moveEvent.start.y;
						
					let maxLeft = rect.width - this._moveEvent.data.w,
						maxTop = rect.height - this._moveEvent.data.h;
						
					this._moveEvent.data.x = Math.max(0, Math.min(maxLeft, left));
					this._moveEvent.data.y = Math.max(0, Math.min(maxTop, top));
				}
			},
			
			moveEndEvent() {
				this._resizeEvent && (this._resizeEvent.data.active = false);
				this._moveEvent && (this._moveEvent.data.active = false);
				this._resizeEvent = this._moveEvent = false;
				window.removeEventListener('mousemove', this.moveEvent);
				window.removeEventListener('mouseup', this.moveEndEvent);
			},
			
			resizeHandle(data, type) {
				let rect = this.$refs.area.getBoundingClientRect();
				data.active = true;
				data.index = this.areaIndex++;
				this._resizeEvent = {
					type,
					data,
					start: {}
				}
				
				if ([1, 2].includes(type)) {
					// 向上
					this._resizeEvent.start.h = data.h;
					this._resizeEvent.start.y = data.y;
				} else {
					// 向下
					this._resizeEvent.start.y = rect.top + data.y;
				}
				
				if ([1, 4].includes(type)) {
					// 向左
					this._resizeEvent.start.w = data.w;
					this._resizeEvent.start.x = data.x;
				} else {
					// 向右
					this._resizeEvent.start.x = rect.left + data.x;
				}
				
				window.addEventListener('mousemove', this.moveEvent);
				window.addEventListener('mouseup', this.moveEndEvent);
			},
			
			moveHandle(e, data) {
				data.active = true;
				data.index = this.areaIndex++;
				this._moveEvent = {
					data,
					start: {
						x: -e.layerX,
						y: -e.layerY
					}
				}
				
				window.addEventListener('mousemove', this.moveEvent);
				window.addEventListener('mouseup', this.moveEndEvent);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.area {
		position: relative;
		cursor: pointer;
		user-select: none;
		overflow: hidden;
		
		&-box {
			width: 375px;
			margin: 0 auto;
		}
		
		&:before {
			content: '';
			position: absolute;
			inset: 0;
		}
		
		img {
			width: 100%;
			max-height: none;
		}
		
		&-item {
			position: absolute;
			white-space: nowrap;
			color: #fff;
			background: rgba(0,168,255,.7);
			opacity: .8;
			cursor: move;
			
			&:hover,
			&[active] {
				z-index: 1;
				opacity: 1;
			}
			
			&-handle {
				position: absolute;
				width: 6px;
				height: 6px;
				border: 1px solid #25A9EE;
				background: #fff;
				cursor: se-resize;
				
				&:nth-child(1) {
					left: 0;
					top: 0;
				}
				&:nth-child(2) {
					right: 0;
					top: 0;
					cursor: sw-resize;
				}
				&:nth-child(3) {
					right: 0;
					bottom: 0;
				}
				&:nth-child(4) {
					left: 0;
					bottom: 0;
					cursor: sw-resize;
				}
			}
		}
		
		&-handle {
			height: 44px;
			border-bottom: 1px dotted #ddd;
			
			a {
				color: #004EDC;
			}
		}
		
		&-link {
			margin-top: 14px;
			
			label {
				width: 4em;
			}
			
			a {
				padding: 5px;
				margin-left: 5px;
				font-size: 16px;
				color: #f77;
				
				&:hover {
					color: #f00;
				}
			}
		}
	}
</style>
